import React from "react";

const Landing = () => {
  return (
    <div className="loading fullscreen">
      <div className="loading-container">
        <img
          className="w-100"
          src={`${process.env.PUBLIC_URL}/assets/images/loading-logo.png`}
          alt="Cargando..."
        />
      </div>
    </div>
  );
};

export default Landing;
